import React from 'react'
import { strings } from '../../../localization/strings'
import Typography from '@material-ui/core/Typography/Typography'

const styles = {
    table: {
        display: 'flex',
        flexDirection: 'column',
    },
    row: {
        display: 'flex',
        flexWrap: 'wrap',
        padding: '8px 8px',
        borderBottom: '1px solid #f7b500',
    },
    row_underline: {
        display: 'flex',
        flexWrap: 'wrap',
        padding: '8px 8px',
        borderBottom: '3px solid #f7b500',
    },
    cell: {
        flexGrow: 1,
        width: 180,
    },
}

class Component extends React.Component {
    state = {}

    render() {
        let { summaryItems } = this.props

        if (!summaryItems) {
            return null
        }

        if (!summaryItems.length) {
            return null
        }

        const totalCount = summaryItems.reduce((x, y) => ({
            ...x,
            Count: x.Count + y.Count,
        })).Count
        const totalNoVatAmount = summaryItems.reduce((x, y) => ({
            ...x,
            TotalNoVatAmount: x.TotalNoVatAmount + y.TotalNoVatAmount,
        })).TotalNoVatAmount
        const totalAmount = summaryItems.reduce((x, y) => ({
            ...x,
            TotalAmount: x.TotalAmount + y.TotalAmount,
        })).TotalAmount

        return (
            <div style={{ paddingLeft: 20, paddingRight: 20 }}>
                <Typography variant={'body1'} style={styles.row_underline}>
                    {strings.movements_totals_title}
                </Typography>

                <div style={styles.table}>
                    <div
                        style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            padding: '8px 8px',
                        }}
                    >
                        <div style={styles.cell}>
                            <Typography noWrap>
                                {strings.movements_totals_totalAmount}
                            </Typography>
                        </div>
                        <div style={styles.cell}>
                            <Typography noWrap>
                                $ {totalAmount.toFixed(2)}
                            </Typography>
                        </div>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            padding: '8px 8px',
                        }}
                    >
                        <div style={styles.cell}>
                            <Typography noWrap>
                                {strings.movements_totals_totalAmountNoVatLabel}
                            </Typography>
                        </div>
                        <div style={styles.cell}>
                            <Typography noWrap>
                                $ {totalNoVatAmount.toFixed(2)}
                            </Typography>
                        </div>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            padding: '8px 8px',
                        }}
                    >
                        <div style={styles.cell}>
                            <Typography noWrap>
                                {strings.movements_totals_totalCountLabel}
                            </Typography>
                        </div>
                        <div style={styles.cell}>
                            <Typography noWrap>{totalCount}</Typography>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Component
